module.exports = __webpack_public_path__ + "img/arrow-left-icon.85f22fc4.svg";